var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { AuthenticationService } from '../shared/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { environment } from '../../../environments/environment';
import { CuiBaseComponent } from '@cicero/webui/lib/core/shared/base-component';
var blockedError = 'Kodeordet til denne bruger er blevet indtastet forkert tre gange i træk. ' +
    'Brugeren er blokeret i 20 minutter fra blokeringstidspunktet. Kontakt evt. din systemadministrator.';
var forbiddenError = 'Forkert brugernavn eller kodeord';
/**
 * Shows a login form and agency name.
 */
var LoginComponent = /** @class */ (function (_super) {
    __extends(LoginComponent, _super);
    function LoginComponent(auth, router, route, snackBar) {
        var _this = _super.call(this) || this;
        _this.auth = auth;
        _this.router = router;
        _this.route = route;
        _this.snackBar = snackBar;
        _this.loading = true;
        return _this;
    }
    LoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        var agencySub = this.route.params
            .do(function () { return _this.loading = true; })
            .switchMap(function (params) { return _this.auth.getAgency(params.agencyISIL.toUpperCase()); })
            .do(function () { return _this.loading = false; })
            .subscribe(function (agency) { return _this.agency = agency; });
        this.pushSubscription(agencySub);
    };
    /**
     * Atempt a login.
     * The user is redirected if it succeeds.
     * If it fails a snackbar is shown.
     */
    LoginComponent.prototype.submit = function () {
        var _this = this;
        this.snackBar.dismiss();
        var agencyISIL = this.route.snapshot.params.agencyISIL.toUpperCase();
        this.auth.login(this.username, this.password, agencyISIL)
            .subscribe(function () { return _this.redirect(); }, function (response) {
            _this.snackBar.open(response.error === 'BLOCKED' ? blockedError : forbiddenError, undefined, { duration: environment.errorMessageDurationMs });
        });
    };
    /**
     * Redirect the user away from the login page.
     * If a redirectTo query parameter is present, redirect to it.
     * Otherwise redirect to the front page for the agency.
     */
    LoginComponent.prototype.redirect = function () {
        var redirectTo = this.route.snapshot.queryParams.redirectTo;
        if (redirectTo) {
            this.router.navigateByUrl(redirectTo);
        }
        else {
            this.router.navigate(['../pick-up-list/search'], { relativeTo: this.route });
        }
    };
    return LoginComponent;
}(CuiBaseComponent));
export { LoginComponent };



// WEBPACK FOOTER //
// ./src/app/authentication/login/login.component.ts.pre-build-optimizer.js